export default __webpack_public_path__ + "static/media/135.8dd71cb4.jpg";